/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Meta_DescriptionInputs */

const es_exp_mk_meta_description = /** @type {(inputs: Exp_Mk_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Súmate a una salida o publica la tuya. Comparte la travesía y comparte el gasto. Experiencias es la forma más fácil de navegar más, tengas barco o no.`)
};

const gl_exp_mk_meta_description = /** @type {(inputs: Exp_Mk_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Súmate a unha saída ou publica a túa. Comparte a travesía e comparte o gasto. Experiencias é a forma máis doada de navegar máis, teñas barco ou non.`)
};

const en_exp_mk_meta_description = /** @type {(inputs: Exp_Mk_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join a trip or publish your own. Share the voyage and share the cost. Experiences is the easiest way to sail more — with or without a boat.`)
};

/**
* | output |
* | --- |
* | "Join a trip or publish your own. Share the voyage and share the cost. Experiences is the easiest way to sail more — with or without a boat." |
*
* @param {Exp_Mk_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_meta_description = /** @type {((inputs?: Exp_Mk_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_meta_description(inputs)
	if (locale === "en") return en_exp_mk_meta_description(inputs)
	return es_exp_mk_meta_description(inputs)
});